import type { FC } from "react";

interface GxUploadFileCancelBtnProps {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
}

const GxUploadFileCancelBtn: FC<GxUploadFileCancelBtnProps> = ({
  onClick,
  disabled = false,
  label = "Cancel",
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="gx-p16-b gx-upload-file-cancel-btn"
    >
      {label}
    </button>
  );
};

export default GxUploadFileCancelBtn;
